import { NOTIFICATION_TYPES } from '../contexts/NotificationContext';

// Função para criar notificação de comunicado
export const createAnnouncementNotification = (senderName, message) => ({
  type: NOTIFICATION_TYPES.ANNOUNCEMENT,
  title: `${senderName} enviou um novo comunicado`,
  message: message,
  timestamp: new Date().toISOString()
});

// Função para criar notificação de moedas ganhas
export const createCoinsNotification = (amount) => ({
  type: NOTIFICATION_TYPES.COINS_EARNED,
  title: 'Você ganhou moedas pelo seu acesso de hoje!',
  message: `Parabéns! Você ganhou ${amount} moedas por acessar o sistema hoje.`,
  timestamp: new Date().toISOString()
});

// Função para criar notificação de celebração
export const createCelebrationNotification = (senderName, isComment = false) => ({
  type: NOTIFICATION_TYPES.CELEBRATION,
  title: isComment 
    ? `${senderName} comentou em uma celebração com você!`
    : `${senderName} celebrou com todos!`,
  message: isComment 
    ? `${senderName} deixou um comentário em uma celebração que você participou.`
    : `${senderName} iniciou uma nova celebração para toda a equipe!`,
  timestamp: new Date().toISOString()
});

// Função para criar notificação de feedback
export const createFeedbackNotification = (senderName) => ({
  type: NOTIFICATION_TYPES.FEEDBACK,
  title: `${senderName} enviou um feedback para você`,
  message: `${senderName} compartilhou um feedback sobre seu trabalho. Clique para visualizar.`,
  timestamp: new Date().toISOString()
});

// Função para criar notificação de reunião agendada
export const createMeetingNotification = (meetingType = '1:1') => ({
  type: NOTIFICATION_TYPES.SCHEDULED_MEETING,
  title: `Você tem ${meetingType} agendada pra hoje`,
  message: `Revise seus tópicos clicando aqui :)`,
  timestamp: new Date().toISOString()
});

// Função para criar notificação de comentário
export const createCommentNotification = (senderName, context) => ({
  type: NOTIFICATION_TYPES.COMMENT,
  title: `${senderName} comentou em ${context}`,
  message: `${senderName} deixou um novo comentário. Clique para visualizar.`,
  timestamp: new Date().toISOString()
});

// Função para criar notificação de nova mensagem
export const createMessageNotification = (roomId, message) => ({
  type: NOTIFICATION_TYPES.NEW_MESSAGE,
  title: 'Nova mensagem do cliente',
  message: message,
  roomId: roomId,
  timestamp: new Date().toISOString()
});

// Função para criar notificação de novo cliente
export const createNewClientNotification = (clientName) => ({
  type: NOTIFICATION_TYPES.NEW_CLIENT,
  title: 'Novo cliente em espera',
  message: `${clientName} entrou na fila de espera.`,
  timestamp: new Date().toISOString()
});

// Função para criar notificação de transferência
export const createTransferNotification = (fromName, toName) => ({
  type: NOTIFICATION_TYPES.TRANSFER,
  title: 'Conversa transferida',
  message: `Conversa transferida de ${fromName} para ${toName}.`,
  timestamp: new Date().toISOString()
});

// Função para criar notificação do sistema
export const createSystemNotification = (title, message) => ({
  type: NOTIFICATION_TYPES.SYSTEM,
  title: title,
  message: message,
  timestamp: new Date().toISOString()
});

// Função para criar notificações de exemplo (para teste)
export const createSampleNotifications = () => [
  createAnnouncementNotification('Matheus Di Carlos Torres', 'Novo comunicado sobre atualizações do sistema'),
  createCoinsNotification(50),
  createCelebrationNotification('Flávia Regina Alexandre', true),
  createCelebrationNotification('Alexandre Ramires da Silva'),
  createFeedbackNotification('Alexandre Ramires da Silva'),
  createCoinsNotification(30),
  createMeetingNotification('1:1'),
  createCommentNotification('Gisele Souza Cavalcante', 'uma celebração com você'),
  createMessageNotification('room123', 'Olá, preciso de ajuda com meu pedido'),
  createNewClientNotification('João Silva'),
  createTransferNotification('Maria Santos', 'Carlos Oliveira'),
  createSystemNotification('Manutenção Programada', 'O sistema ficará indisponível das 02:00 às 04:00 para manutenção.')
];
